import React from 'react'

const Requisiciones = () => {
  return (
    <div style={{textAlign: "center"}}>Requisiciones</div>
  )
}

export default Requisiciones